import React from 'react';
import { EpiContext } from '../../Shared/Scripts/Store/EpiContext/Types';
import VeilederBarnestipendDto from '../Models/VeilederBarnestipendDto';
import { connect } from 'react-redux';
import { VeilederBarnestipendAppState } from '../Store';
import { toggleVilkar } from '../Store/Valg/Actions';
import contentResolver from '../../Shared/Scripts/Utilities/EpiContentResolver';
import { resolveRawText } from '../../Shared/Scripts/Utilities/EpiContentResolver';
import { ModalCompontent } from '../../Shared/Scripts/Components/ModalComponent';
import { updateZIndex } from '../../Shared/Scripts/Store/EpiContext/Actions';
import { BarnestipendSatser } from '../Utilities/BarnestipendApi';
import { updateLiveMessage } from '../../Shared/Scripts/Utilities/LiveMessage';
import { ArticleContentComponent } from '../../Shared/Scripts/Components/ArticleContentComponent';

interface ResultOwnProps {
    boksId: string;

    tittelInntekt: keyof VeilederBarnestipendDto;
    innholdInntekt: JSX.Element;

    tittelFormueTrygd: keyof VeilederBarnestipendDto;
    innholdFormueTrygd: JSX.Element;

    tittelKontroll: keyof VeilederBarnestipendDto;
    innholdKontroll: JSX.Element | null;

    eventId: string | null;
}

type ResultatProps = MapStateToProps & MapDispatchToProps & ResultOwnProps;

class ResultatComponent extends React.PureComponent<ResultatProps> {
    constructor(props: ResultatProps) {
        super(props);
        this.onVilkarClick = this.onVilkarClick.bind(this);
        this.onRequestClose = this.onRequestClose.bind(this);
    }

    onRequestClose(): void {
        this.props.updateZIndex(1);
        this.props.toggleVilkar();
    }

    onVilkarClick(event: React.MouseEvent): void {
        this.props.updateZIndex(2);
        this.props.toggleVilkar();
    }
    componentDidMount(): void {
        updateLiveMessage();
    }

    render(): JSX.Element {
        const {
            visVilkar,
            epiContext,
            tittelInntekt,
            innholdInntekt,
            tittelFormueTrygd,
            innholdFormueTrygd,
            tittelKontroll,
            innholdKontroll,
            boksId,
            eventId,
        } = this.props;

        return (
            <div id={boksId} className="c-veileder__panel c-veileder__panel--resultat c-veileder__panel--white-aubergine">
                <div className="c-veileder__panel-row">
                    <div className="c-veileder__content c-veileder__content--header">
                        <h3 className="c-veileder__tittel c-veileder__tittel--resultat">
                            {contentResolver(epiContext, tittelInntekt)}
                        </h3>
                    </div>

                    <div className="c-veileder__content c-veileder__content--with-space c-veileder__content--indented">
                        <div className="c-veileder__tekst">{innholdInntekt}</div>
                    </div>
                </div>

                <div className="c-veileder__panel-row">
                    <div className="c-veileder__content c-veileder__content--header">
                        <h3 className="c-veileder__tittel c-veileder__tittel--resultat">
                            {contentResolver(epiContext, tittelFormueTrygd)}
                        </h3>
                    </div>
                    <div className="c-veileder__content c-veileder__content--with-space c-veileder__content--indented">
                        <div className="c-veileder__tekst">{innholdFormueTrygd}</div>
                    </div>
                </div>

                <div className="c-veileder__panel-row">
                    <div className="c-veileder__content c-veileder__content--header">
                        <h3 className="c-veileder__tittel c-veileder__tittel--resultat">
                            {contentResolver(epiContext, tittelKontroll)}
                        </h3>
                    </div>

                    <div className="c-veileder__content c-veileder__content--with-space c-veileder__content--indented">
                        <div className="c-veileder__tekst">{innholdKontroll}</div>
                    </div>
                </div>

                <div className="c-veileder__panel-row">
                    <div className="c-veileder__content c-veileder__content--footer">
                        <button type="button" className="c-knapp c-knapp--lenke" onClick={this.onVilkarClick}>
                            {contentResolver(epiContext, 'vilkarLenketekst')}
                        </button>
                        <ModalCompontent
                            isOpen={visVilkar}
                            onRequestClose={this.onRequestClose}
                            ariaCloseText={resolveRawText(epiContext, 'vilkarAriaLabel')}
                            eventId={eventId}
                        >
                            <ArticleContentComponent
                                headerinnhold={contentResolver(epiContext, 'vilkarTittel', 2)}
                                contentinnhold={contentResolver(epiContext, 'vilkarInnhold', 2)}
                            />
                        </ModalCompontent>
                    </div>
                </div>
            </div>
        );
    }
}

interface MapStateToProps {
    epiContext: EpiContext<VeilederBarnestipendDto>;
    visVilkar: boolean;
    satser: BarnestipendSatser | null;
    locale: string;
}

interface MapDispatchToProps {
    toggleVilkar: typeof toggleVilkar;
    updateZIndex: typeof updateZIndex;
}

export default connect(
    (state: VeilederBarnestipendAppState): MapStateToProps => {
        return {
            epiContext: state.epiContext,
            visVilkar: state.valg.visVilkar,
            satser: state.satser,
            locale: state.epiContext.locale,
        };
    },
    { toggleVilkar, updateZIndex },
)(ResultatComponent);
